import { Button } from '@eventbrite/eds-button';
import { gettext } from '@eventbrite/i18n';
import { logEvent } from '@eventbrite/statsig';
import React from 'react';
import { STATSIG_EVENT_NAMES } from '../../../constants';
import type { OrganizerInfoExperimentVariantValues } from '../../../types';
import { FollowButtonContext } from './context';
import './FollowButton.scss';

export type FollowButtonProps = {
    closeGDPRModal: () => void;
    closeLoginModal: () => void;
    followersCount: number | null;
    isFollowing: boolean;
    onChangeFollow: () => void;
    shouldShowLoginModal: boolean;
    shouldShowGDPRModal: boolean;
    userId?: number;
    organizerPanelVariantVersion: OrganizerInfoExperimentVariantValues;
};

type ButtonProps = {
    isFollowing: boolean;
    onChangeFollow?: () => void;
};

const FOLLOW_TEXT = gettext('Follow');
const FOLLOWING_TEXT = gettext('Following');

export const useFollowButton = () => {
    const followButtonProps = React.useContext(FollowButtonContext);
    return {
        isFollowing: followButtonProps?.isFollowing || false,
        onChangeFollow: followButtonProps?.onChangeFollow,
        organizerPanelVariantVersion:
            followButtonProps?.organizerPanelVariantVersion,
    };
};

export const useFollowCount = () => {
    const followButtonProps = React.useContext(FollowButtonContext);
    return followButtonProps?.followersCount;
};

const BlueFollowButtonVariant = ({
    isFollowing,
    onChangeFollow,
}: ButtonProps) => {
    return (
        <Button
            style={'follow'}
            onClick={() => {
                onChangeFollow?.();
                logEvent(
                    STATSIG_EVENT_NAMES.LISTING_ORGANIZER_FOLLOW_BUTTON,
                    isFollowing ? 'Unfollow' : 'Follow',
                );
            }}
            isFollowing={isFollowing}
            __containerClassName="follow-button-variant-a"
            data-testid="follow-button-variant-a"
        >
            {isFollowing ? FOLLOWING_TEXT : FOLLOW_TEXT}
        </Button>
    );
};

export const FollowButton = () => {
    const { isFollowing, onChangeFollow } = useFollowButton();
    return (
        <BlueFollowButtonVariant
            isFollowing={isFollowing}
            onChangeFollow={onChangeFollow}
        />
    );
};
